import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth.interceptor';
import { HttpErrorInterceptor } from './error.interceptor';
import { MockBackendInterceptor } from './mock-backend.interceptor';
import { ApimSubscriptionInterceptor } from './apim-subscription.interceptor';

/** Http interceptor providers in outside-in order */
export const INTERCEPTOR_PROVIDER = [
    // Mock Backend Interceptor - يجب أن يكون أول interceptor لاعتراض جميع الطلبات
    { provide: HTTP_INTERCEPTORS, useClass: MockBackendInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApimSubscriptionInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true }
];
